import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function PublicEnrollmentPage() {
  const [corsi, setCorsi] = useState([]);
  const [done, setDone] = useState(false);
  const [form, setForm] = useState({ nome:"", cognome:"", email:"", telefono:"", codice_fiscale:"", citta:"", corso_id:"", note:"" });

  useEffect(() => { api.get("/pubblico/corsi-aperti").then(r=>setCorsi(r.data)).catch(()=>{}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/iscrizioni", form);
      setDone(true);
      toast.success("Iscrizione inviata!");
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(Array.isArray(d) ? (d.map(x => (x.msg || "").replace("Value error, ", "")).join(" · ") || "Errore di validazione") : (d || "Errore invio"));
    }
  };

  if (done) return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F8FAFC]">
      <Card className="p-8 max-w-md text-center bg-white border-[#E2E8F0]">
        <CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto mb-4"/>
        <h1 className="text-2xl font-bold text-stone-900 mb-2">Iscrizione ricevuta</h1>
        <p className="text-stone-600 mb-6">Grazie! La segreteria di Centro Studi ISTEFORM ti contatterà a breve per completare la procedura.</p>
        <Link to="/"><Button className="bg-[#F7941E] hover:bg-[#E08316] text-white">Torna alla home</Button></Link>
      </Card>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#F8FAFC] py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-[#F7941E] mb-2">Formazione Accreditata Regione Calabria</div>
          <h1 className="font-brand text-4xl text-[#C96F0E]">Iscriviti ai Corsi ISTEFORM</h1>
          <p className="text-stone-600 mt-2">Compila il form per pre-iscriverti. Ti ricontatteremo per il contratto e i documenti.</p>
        </div>
        <Card className="p-8 bg-white border-[#E2E8F0]">
          <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div><Label>Nome</Label><Input data-testid="iscr-nome" required value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}/></div>
            <div><Label>Cognome</Label><Input data-testid="iscr-cognome" required value={form.cognome} onChange={e=>setForm({...form,cognome:e.target.value})}/></div>
            <div><Label>Email</Label><Input data-testid="iscr-email" type="email" required value={form.email} onChange={e=>setForm({...form,email:e.target.value})}/></div>
            <div><Label>Telefono</Label><Input data-testid="iscr-telefono" value={form.telefono} onChange={e=>setForm({...form,telefono:e.target.value})}/></div>
            <div><Label>Codice Fiscale</Label><Input data-testid="iscr-cf" value={form.codice_fiscale} onChange={e=>setForm({...form,codice_fiscale:e.target.value.toUpperCase()})}/></div>
            <div><Label>Città</Label><Input data-testid="iscr-citta" value={form.citta} onChange={e=>setForm({...form,citta:e.target.value})}/></div>
            <div className="col-span-2"><Label>Corso di interesse</Label>
              <Select value={form.corso_id} onValueChange={v=>setForm({...form,corso_id:v})} required>
                <SelectTrigger data-testid="iscr-corso-select"><SelectValue placeholder="Seleziona corso"/></SelectTrigger>
                <SelectContent>{corsi.map(c=><SelectItem key={c.id} value={c.id}>{c.titolo} ({c.durata_ore}h){c.sede ? ` - ${c.sede}` : ""}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="col-span-2"><Label>Note</Label><Textarea data-testid="iscr-note" value={form.note} onChange={e=>setForm({...form,note:e.target.value})} placeholder="Domande o richieste"/></div>
            <div className="col-span-2 mt-2">
              <Button type="submit" size="lg" className="w-full bg-[#F7941E] hover:bg-[#E08316] text-white" data-testid="iscr-submit-btn">Invia richiesta</Button>
            </div>
          </form>
        </Card>
        <div className="text-center mt-6"><Link to="/" className="text-sm text-[#F7941E] hover:underline">← Torna alla home</Link></div>
      </div>
    </div>
  );
}
